import { Navigate, Route, Routes } from "react-router-dom";

import { ConfigUIGate } from "../../components/custom/ConfigUIGate";
import { useFetchFeatureConfig } from "../../hooks/useFetchFeatureConfig";
import { DeploymentIntegrationsLayout } from "../../integrations/components/deployment/DeploymentIntegrationsLayout";
import { DeploymentSourcesList } from "../../integrations/components/deployment/DeploymentSourcesList";
import { DeploymentSourceWorkspaces } from "../../integrations/components/deployment/DeploymentSourceWorkspaces";
import { SettingsContent } from "../components/SettingsContent";

interface SettingsRoutesProps {
  layout: React.ReactElement;
}

const MemoriesGuard = () => {
  const { data: featureConfig } = useFetchFeatureConfig();
  if (featureConfig && featureConfig.memories === false) {
    return <Navigate to="../general" replace />;
  }
  return (
    <div className="mx-auto w-full max-w-4xl px-8 py-8">
      <SettingsContent section="memories" />
    </div>
  );
};

export const SettingsRoutes = ({ layout }: SettingsRoutesProps) => {
  return (
    <Routes>
      <Route element={layout}>
        <Route index element={<Navigate to="general" replace />} />
        <Route
          path="general"
          element={
            <div className="mx-auto w-full max-w-4xl px-8 py-8">
              <SettingsContent section="general" />
            </div>
          }
        />
        <Route path="memories" element={<MemoriesGuard />} />
        <Route
          path="deployment-integrations"
          element={
            <ConfigUIGate feature="console_deployment_integrations">
              <DeploymentIntegrationsLayout />
            </ConfigUIGate>
          }
        >
          <Route index element={<DeploymentSourcesList />} />
          <Route path=":source" element={<DeploymentSourceWorkspaces />} />
        </Route>
      </Route>
    </Routes>
  );
};
